import type { UIMediaItem } from '@/types/ui-media';

export interface TweetMediaProperties {
  mediaItems: readonly UIMediaItem[];
  onViewerStateChange?: (isActive: boolean) => void;
}

export interface MediaViewerState {
  inlineVideoIndex: number | null;
  isDialogOpen: boolean;
  selectedIndex: number | undefined;
}

export const MEDIA_KEY_BINDINGS = Object.freeze({
  ESCAPE: 'Escape',
  PREVIOUS: 'ArrowLeft',
  NEXT: 'ArrowRight',
} satisfies Record<string, string>);

export type MediaKeyBinding = (typeof MEDIA_KEY_BINDINGS)[keyof typeof MEDIA_KEY_BINDINGS];
